import { useTranslation } from 'react-i18next';
import { ChevronLeft } from '@mui/icons-material';
import { TouchButton } from 'greener-ui-library';

export function HmiMenuBackButton({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation();

  return (
    <TouchButton
      onClick={onClick}
      variant="outlined"
      size="large"
      sx={{ width: 56 }}
      aria-label={t('projects:hmi.backButtonLabel')}
    >
      <ChevronLeft />
    </TouchButton>
  );
}
